import { SelectResult } from '../components/select/select-chain.component';
import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export interface WOReportRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  unitID?: number;
  serviceID?: number;
  inspectorID?: number;
  wOStatusID?: number;
  dateFrom?: string;
  dateTo?: string;
  dateCriteria?: string;
  duxInspectionRequestType?: number;
  projectStatus?: string;
  showAll?: string;
  departments?: any[];
  // scheduledDateFrom?:string;
  // scheduledDateTo?:string;
}

const getWOReportWithFilters = (filter: WOReportRequestArgs) => {
  const {
    customerID,
    officeID,
    projectID,
    unitID,
    serviceID,
    inspectorID,
    wOStatusID,
    dateFrom,
    dateTo,
    duxInspectionRequestType,
    projectStatus,
    dateCriteria,
    departments
  } = filter;

  let queryString = '';

  if (customerID) {
    queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
  }
  if (officeID) {
    queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
  }
  if (projectID) {
    queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
  }
  if (unitID) {
    queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
  }
  if (serviceID) {
    queryString += `${queryString ? '&' : ''}ServiceID=${serviceID}`;
  }
  if (inspectorID) {
    queryString += `${queryString ? '&' : ''}InspectorID=${inspectorID}`;
  }
  if (wOStatusID) {
    queryString += `${queryString ? '&' : ''}WOStatusID=${wOStatusID}`;
  }
  if (dateFrom) {
    queryString += `${queryString ? '&' : ''}DateFrom=${dateFrom}`;
  }
  if (dateTo) {
    queryString += `${queryString ? '&' : ''}DateTo=${dateTo}`;
  }
  if (duxInspectionRequestType) {
    queryString += `${queryString ? '&' : ''}DuxInspectionRequestType=${duxInspectionRequestType}`;
  }
  if (dateCriteria) {
    queryString += `${queryString ? '&' : ''}DateCriteria=${dateCriteria}`;
  }
  if (projectStatus) {
    queryString += `${queryString ? '&' : ''}ProjectStatus=${projectStatus}`;
  }
  if ((departments ?? []).length > 0) {
    queryString += `${queryString ? '&' : ''}Departments=${departments}`;
  }
  // if (scheduledDateFrom) {
  //   queryString += `${queryString ? '&' : ''}ScheduledDateFrom=${scheduledDateFrom}`;
  // }
  // if (scheduledDateTo) {
  //   queryString += `${queryString ? '&' : ''}ScheduledDateTo=${scheduledDateTo}`;
  // }
  return queryString;
};
export const workorderReportApiKeyStore = {
  getWorkOrderReportDateCriteria: (): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDER_REPORT_DATECRITERIA`],
    route: `/Workorder/Report/DateCriteria`,
  }),
  getWorkOrderInspectionReports: (args: WOReportRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_WORKORDER_INSPECTION_REPORTS`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
        args.serviceID,
        args.inspectorID,
        args.wOStatusID,
        args.dateFrom,
        args.dateTo,
        args.dateCriteria,
        args.projectStatus,
        args.showAll,
      ].filter((a) => a),
    ],
    route: `/WorkOrder/WorkOrderInspectionRequestReport?${getWOReportWithFilters(args)}`,
  }),
  getDuxInspectionRequest: (args: WOReportRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_DUX_INSPECTION_REQUEST`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
        args.serviceID,
        args.inspectorID,
        args.wOStatusID,
        args.dateFrom,
        args.dateTo,
        args.dateCriteria,
        args.duxInspectionRequestType,
        args.departments,
        args.showAll,
      ].filter((a) => a),
    ],
    route: `/WorkOrder/DuxInspectionRequestReport?${getWOReportWithFilters(args)}`,
  }),

  getWorkOrderExceptionReports: (args: string): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDER_EXCEPTION_REPORTS`],
    route: `/WorkOrder/QBOExceptionReport?ExceptionType=${args}`,
  }),

  getWorkOrderLog: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_WORK_ORDER_LOG`, workorderID],
    route: `/Audit/WorkOrderLogs/${workorderID}`,
    isEnabled: !!workorderID,
  }),
  getWorkOrderReports: (): MutationKeyConfig => ({
    mutationKey: [`GET_WORK_ORDER_REPORTS`],
    route: `/WorkOrder/WorkOrderReport`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getDuxInspectionRequestData: (): MutationKeyConfig => ({
    mutationKey: [`GET_DUX_INSPECTION_REQUEST_DATA`],
    route: `/WorkOrder/DuxInspectionRequestReport`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getWorkOrderReportsPaging: (): MutationKeyConfig => ({
    mutationKey: [`GET_WORK_ORDER_REPORTS_PAGING`],
    route: `/WorkOrder/WorkOrderReportWithPagination`,
    action: 'POST',
    disableSnackbar: true,
  }),
  exportWorkOrderReportExcel: (): MutationKeyConfig => ({
    mutationKey: [`EXPORT_WORK_ORDER_REPORT_EXCEL`],
    route: `/Export/WorkOrderReport`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getDuxSyncLog: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_DUX_SYNC_LOG`, workorderID],
    route: `/Audit/WorkOrderDUXSyncLogs/${workorderID}`,
    isEnabled: !!workorderID,
  }),
  getEmailLog: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_EMAIL_LOG`, workorderID],
    route: `/Audit/GetWorkOrderEmailAuditLogs/${workorderID}`,
    isEnabled: !!workorderID,
  }),
};
